module.exports = __webpack_public_path__ + "eb2fdc23d292651bcee609fae192dcce.svg";